module.exports = __webpack_public_path__ + "img/embay-store 1.ce9c9f4a.png";